import Vue from 'vue'
import { isAllowed } from '../utils/authentication'

/**
 * Directive to display element only if user has given role
 * @example
 *  <v-btn v-role:contrib>OK</v-btn> : Will display Ok btn only for contrib users (of all divisions)
 *  <v-btn v-role:admin>OK</v-btn> : Will display Ok btn only for admin users (of all divisions)
 *  <v-btn v-role:contrib:"'fbp'">OK</v-btn> : Will display Ok btn only for contrib users of division FBP (also 3div)
 *  <v-btn v-role:contrib:"'fbp,fsh'">OK</v-btn> : Will display Ok btn only for contrib users of division FBP and FSH (also 3div)
 */
Vue.directive('role', function(el, binding, vnode) {
  const user = vnode.context.$store.getters['authentication/user']
  const role = binding.arg ? binding.arg.toUpperCase() : null
  const divisions = binding.value
    ? binding.value.split(',').map(d => d.toUpperCase())
    : undefined

  if (!isAllowed(user, role, divisions)) {
    el.style.display = 'none'
  }
})
